export default __webpack_public_path__ + "static/media/absintheDrinker.c68df56c.jpg";